const DOMAIN_TYPE = {
    CUSTOM: "CUSTOM",
    SUB: "SUB",
}

export default DOMAIN_TYPE;